import { styled } from "@mui/material/styles";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  Link,
  IconButton,
  Divider,
  ListItemButton,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import FileCopyIcon from "@mui/icons-material/FileCopy";

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
}));

export default function FilesList(props) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Demo>
          <List>
            {props.folders.map((folder, idx) => [
              <Divider key={idx + 2} />,
              <ListItemButton
                key={idx}
                onClick={() => props.onChange(folder.fullPath)}
                // secondaryAction={
                //   <IconButton edge="end" aria-label="delete folder" onClick={() => props.onDeleteFolder(folder)}>
                //     <DeleteIcon />
                //   </IconButton>
                // }
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText
                  primary={folder.name}
                  // secondary={"Secondary text"}
                />
              </ListItemButton>,
              <Divider key={idx + 1} />,
            ])}
            {props.files.map((file, idx) => [
              <ListItem
                key={idx}
                secondaryAction={
                  <IconButton
                    edge="end"
                    disabled={!props.onDeleteFile}
                    aria-label="delete file"
                    onClick={() => props.onDeleteFile(file)}
                  >
                    <DeleteIcon />
                  </IconButton>
                }
              >
                <ListItemIcon>
                  <FileCopyIcon />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link target="_blank" href={file.url}>
                      {file.name}
                    </Link>
                  }
                  secondary={
                    file.size
                      ? file.size < 1000000
                        ? `Size: ${(file.size / 1024).toFixed(2)} KB`
                        : `Size: ${(file.size / (1024 * 1024)).toFixed(2)} MB`
                      : null
                  }
                />
              </ListItem>,
              <Divider key={idx + 1} />,
            ])}
          </List>
        </Demo>
      </Grid>
    </Box>
  );
}
